import type { MailchimpDashboardComponentProps } from "./MailchimpDashboardComponent";

export const MailchimpDashboardComponent = {
    MountAsync: async (target: HTMLElement, props: MailchimpDashboardComponentProps) => {
        const { mountReactComponentAsync } = await import("../../../js/mountReactComponentAsync");
        const { MailchimpDashboardComponent } = await import("./MailchimpDashboardComponent");
        return await mountReactComponentAsync(target, MailchimpDashboardComponent, props);
    },
};
